import programTypesConfig from "wwg-utilities/dist/config/programTypesConfig";
import project from "./project";

const programTypes = programTypesConfig[project].programTypes;

export default programTypes;